<template>
  <PageWrapper
    :active-section="SECTION_BILLING"
    :active-page="PAGE_BILLING_HISTORY"
    title="Billing History"
    :breadcrumbs="breadcrumbs"
    page-name="Billing History"
    align="left"
    width="full"
  >
    <SmartFeed
      :pinia-store="useSubscriptionBillingHistoryFeedStore"
      default-smart-feed-layout="table"
      default-entity-layout="tableRow"
    >
      <template #empty-state>
        <iCard width="fill" :style-overrides="{borderWidth: 'none'}">
          <template #body>
            <iColumn gap="large" align="center">
              <iColumn gap="standard" align="center">
                <iSubHeading variant="subtle">
                  No active subscriptions yet
                </iSubHeading>
                <iParagraph
                  variant="subtle"
                  text-align="center"
                  :max-width="400"
                >
                  Your active subscriptions will appear here once.
                </iParagraph>
              </iColumn>
            </iColumn>
          </template>
        </iCard>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_BILLING_HISTORY,
  SECTION_BILLING,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import { useSubscriptionBillingHistoryFeedStore } from "SmartFeed/stores/feed/subscription-billing-history-feed-store";

export default {
  name: "BillingHistory",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_BILLING,
      PAGE_BILLING_HISTORY,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/billing", label: "Billing" },
      ];
    },
  },
  methods: { useSubscriptionBillingHistoryFeedStore },
};
</script>
